import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { SecteurGeographiqueDto } from '@lexi-clients/lexi';
import { SecteurGeographiqueListResult } from '../models/secteur-geographique-list';

@Injectable({
  providedIn: 'root'
})
export class SecteurGeographiqueListService implements IGridService<SecteurGeographiqueDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<SecteurGeographiqueListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/SecteurGeographiques/recherche-devexpress`, { params: params });
  }

  getById(secteurGeographiqueId: number): Observable<SecteurGeographiqueDto> {
    return this.http.get<any>(`${this.baseUrl}/api/SecteurGeographiques/${secteurGeographiqueId}`);
  }

  post(valeur: SecteurGeographiqueDto): Observable<any> {
    return null;
  }

  put(valeur: SecteurGeographiqueDto): Observable<any> {
    return null;
  }

  delete(valeur: SecteurGeographiqueDto): Observable<any> {
    return null;
  }
}
